export class Usertemplate {
  constructor () {
    this.usertemplateWithoutLinkText()
  }

  usertemplateWithoutLinkText () {
    let items = $('[data-no-link="div"]')
    items.each((index, item) => {

      if ($(item).find('.link-arrow [data-ft-type="text"]').html() === '') {
        $(item).find('.icon-arrow-right').css('opacity', '0')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/Usertemplate.js